module.exports = __webpack_public_path__ + "static/media/pagekite.bb8118d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/pagekite.png
// module id = 165
// module chunks = 0